import gql from "graphql-tag";

export const GENERATE_CUSTOM_TOKEN = gql`
  mutation($id: String!) {
    generate_custom_token(id: $id)
  }
`;
